import React from "react";
import { convertFromHTML } from "draft-convert";

export const htmlToStyle = (nodeName, node, currentStyle) => {
  if (nodeName === "strong" || nodeName === "b") {
    return currentStyle.add("BOLD");
  }
  if (nodeName === "em" || nodeName === "i") {
    return currentStyle.add("ITALIC");
  }
  if (nodeName === "u") {
    return currentStyle.add("UNDERLINE");
  }
  if (nodeName === "s" || nodeName === "strike" || nodeName === "del") {
    return currentStyle.add("STRIKETHROUGH");
  }
  if (nodeName === "sup") {
    return currentStyle.add("SUPERSCRIPT");
  }
  if (nodeName === "sub") {
    return currentStyle.add("SUBSCRIPT");
  }
  if (nodeName === "mark") {
    return currentStyle.add("HIGHLIGHT");
  }
  /*if (
    nodeName === "span" &&
    node.style.textAlign === "right" &&
    node.style.display === "block"
  ) {
    return currentStyle.add("RIGHT");
  }

  if (
    nodeName === "span" &&
    node.style.textAlign === "center" &&
    node.style.display === "block"
  ) {
    return currentStyle.add("CENTER");
  }*/

  return currentStyle;
};

export const htmlToEntity = (nodeName, node, createEntity) => {
  const classes = node.classList;
  if (nodeName === "a") {
    if (node.dataset.entity) {
      let data = JSON.parse(node.dataset.entity);
      if (data) {
        return createEntity("USER_LINK", "MUTABLE", data);
      }
    }
  }
  if (nodeName === "span") {
    if (classes.contains("user-input-entity")) {
      if (node.dataset.entity) {
        let data = JSON.parse(node.dataset.entity);
        if (data) {
          return createEntity("USER_INPUT", "SEGMENTED", data);
        }
      }
    }
    if (classes.contains("user-image")) {
      if (node.dataset.entity) {
        let data = JSON.parse(node.dataset.entity);
        if (data) {
          return createEntity("USER_IMAGE", "SEGMENTED", data);
        }
      }
    }
  }
};

export const textToEntity = (text, createEntity) => {
  const result = [];
  /*text.replace(/\@(\w+)/g, (match, name, offset) => {
    const entityKey = createEntity("AT-MENTION", "IMMUTABLE", { name });
    result.push({
      entity: entityKey,
      offset,
      length: match.length,
      result: match,
    });
  });*/
  return result;
};

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case "h1":
      return "header-one";
    case "h2":
      return "header-two";
    case "h3":
      return "header-three";
    case "h4":
      return "header-four";
    case "h5":
      return "header-five";
    case "h6":
      return "header-six";
    case "li":
      if (lastList === "ol") {
        return "ordered-list-item";
      }
      return "unordered-list-item";
    case "blockquote":
      return "blockquote";
    case "pre":
      return "code-block";
    case "div":
    case "p":
      return "unstyled";
    default:
      return null;
  }
}

export const htmlToBlock = (nodeName, node, lastList) => {
  const classes = node.classList;
  let data = node.dataset.block ? JSON.parse(node.dataset.block) : {};
  let type = getBlockTypeForTag(nodeName, lastList);

  if (nodeName === "div" && node.dataset.wordTable) {
    try {
      const wordTable = JSON.parse(node.dataset.wordTable);
      if (Array.isArray(wordTable)) {
        return { type: "word-table", data: { wordTable } };
      }
    } catch (error) {
      // Invalid clipboard data is treated as an ordinary paragraph.
    }
  }

  if (nodeName === "p" && classes.contains("nopadding")) {
    return {
      type: "nopadding",
      data: {},
    };
  }
  if (nodeName === "div" && classes.contains("grid-cell")) {
    if (node.dataset.block) {
      let data = JSON.parse(node.dataset.block);
      if (data) {
        return {
          type: "table",
          data,
        };
      }
    }
  }

  return {
    type,
    data,
  };
};

export const options = {
  htmlToStyle,
  htmlToEntity,
  textToEntity,
  htmlToBlock,
};

const converterFunction = convertFromHTML(options);
export default (html) => converterFunction(html);
